import { initial } from "lodash";
import { dateFormatConDia, dateFormatConDiaShort } from "../../../../utils/DateFunctions";
import vr from "../../../../utils/Verifiers";

export default class Vivero_reporte_procesador {
    dia = '';
    diaR = "";
    general = [];
    semana = "";
    flores = [];
    variedades = [];
    colores = [];
    reporte_por_fecha = [];
    reporte_siembra = [];
    avance_bloques = [];
    avance_bloques_charts = [];
    avance_bloques_individual = [];
    numberFormat = (number) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return 0;
            return format;
        } catch (error) {
            return 0;
        }
    }


    constructor(initial) {
        this.semana = initial?.data?.semana ?? 'No definido';
        let data = initial?.data ?? {};
        this.diaR = data?.dia ?? 'No definido';
        this.dia = dateFormatConDia(data.fecha ?? 'No definido');
        this.extraerReporteSiembra(data?.reporte_siembra ?? {});
        this.extraerReporteFechas(data?.reporte_por_fecha ?? {});
        this.avance_bloques_charts_generar(data?.avance_bloques ?? {});
        this.extraer_avance_bloques_individual(data?.avance_bloques_individual ?? []);
        this.flores = Object.values(initial?.data?.flores?.flores ?? {});
        this.flores.splice(0, 0, { nombre: 'TODAS LAS FLORES', id: -1 });

        this.variedades = Object.values(initial?.data?.flores?.variedades ?? {});
        this.variedades.splice(0, 0, { nombre: 'TODAS LAS VARIEDADES', id: -1 });

        this.colores = Object.values(initial?.data?.flores?.colores ?? {});
        this.colores.splice(0, 0, { nombre: 'TODOS LOS COLORES', id: -1 });
    }

    capitalizeWord(word) {
        if (!word) return '';
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }


    extraer_avance_bloques_individual(apiReport) {
        let len = apiReport.length;
        if (len === 0) {
            this.avance_bloques_individual = [];
            return;
        };

        let keys = Object.keys(apiReport[0]);
        let sintesis = {};
        let accessKeys = [];
        let bloques = [];

        let len_keys = keys.length;
        for (let i = 0; i < len_keys; i++) {
            let key = keys[i];
            if (key === 'bloque_nombre') continue;

            let arrayKey = key.toLocaleUpperCase().split('_');
            let len = arrayKey.length;
            let tipo = arrayKey[len - 1];
            let nombre = arrayKey.slice(0, len - 1).join(' ');
            if (!sintesis[tipo]) {
                sintesis[tipo] = { tipo: tipo, reportes: [] };
            }
            //sintesis[tipo].reportes.push({ nombre: nombre, tipo: tipo, value: 0 });
            accessKeys.push({
                key: key,
                nombre: nombre,
                tipo: tipo
            });
        }
        for (let i = 0; i < len; i++) {
            let nuevoBloque = JSON.parse(JSON.stringify(sintesis));
            let rep = apiReport[i];
            accessKeys.forEach(ak => {
                nuevoBloque[ak.tipo].reportes.push({ nombre: ak.nombre, tipo: ak.tipo, value: vr.numberFormat(rep[ak.key]) });
            });
            nuevoBloque.bloque_nombre = rep.bloque_nombre;
            bloques.push(nuevoBloque);
        }

        this.avance_bloques_individual = bloques;
    }

    generateRandomColor = () => {
        const getRandomValue = () => {
            // Generar un valor entre 64 y 192 para evitar colores muy oscuros o muy claros
            return Math.floor(Math.random() * (192 - 64) + 64);
        };

        const r = getRandomValue();
        const g = getRandomValue();
        const b = getRandomValue();

        // Convertir los valores RGB a hexadecimal
        const toHex = (value) => {
            const hex = value.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };

        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    extraer_avance_bloques(apiReport) {
        let sintesis = {};
        let keys = Object.keys(apiReport);

        keys.forEach(key => {
            let arrayKey = key.toLocaleUpperCase().split('_');
            let len = arrayKey.length;
            let tipo = arrayKey[len - 1];
            let nombre = arrayKey.slice(0, len - 1).join(' ');
            if (!sintesis[tipo]) {
                sintesis[tipo] = { tipo: tipo, reportes: [] };
            }
            sintesis[tipo].reportes.push({ nombre: nombre, tipo: tipo, value: vr.numberFormat(apiReport[key], 0) });
        });
        this.avance_bloques = Object.values(sintesis);
    }

    avance_bloques_charts_generar = (apiRport) => {
        this.extraer_avance_bloques(apiRport);
        let newCharts = {}
        this.avance_bloques.forEach(blq => {

            newCharts[blq.tipo] = {
                config: {
                    name: 'name',
                    keys: [{ key: blq.tipo, color: this.generateRandomColor() }],
                    colores: []
                },
                data: [],
                title: "AVANCE VIVERO REPORTE POR " + blq.tipo.toUpperCase()
            };

            blq.reportes.forEach(rep => {
                newCharts[blq.tipo].data.push({ name: rep.nombre, [blq.tipo]: rep.value });
            });
        });

        this.avance_bloques_charts = Object.values(newCharts);
    }

    extraerReporteFechas = (apiRport) => {
        let sintesis = {};
        let keys = Object.keys(apiRport);

        keys.forEach(key => {
            let arrayKey = key.toLocaleUpperCase().split('_');
            let len = arrayKey.length;
            let tipo = arrayKey[len - 1];
            let periodo = arrayKey[len - 2].toLowerCase();
            let nombre = arrayKey.slice(0, len - 2).join(' ');
            if (!sintesis[nombre]) {
                sintesis[nombre] = { nombre: nombre, };
            }
            if (!sintesis[nombre][periodo]) {
                sintesis[nombre][periodo] = [];
            }
            sintesis[nombre][periodo].push({ tipo: tipo, value: apiRport[key] });
        });
        this.reporte_por_fecha = Object.values(sintesis);
    }

    extraerReporteSiembra = (apiRport) => {
        let sintesis = {};
        let keys = Object.keys(apiRport);

        keys.forEach(key => {
            let arrayKey = key.toLocaleUpperCase().split('_');
            let len = arrayKey.length;
            let periodo = arrayKey[len - 1].toLowerCase();
            let nombre = arrayKey.slice(0, len - 1).join(' ');
            if (!sintesis[nombre]) {
                sintesis[nombre] = { nombre: nombre };
            }
            sintesis[nombre][periodo] = apiRport[key];
        });
        this.reporte_siembra = Object.values(sintesis);
    }

    number_format = (number) => {
        let format = parseFloat(number);
        if (isNaN(format)) return 0;
        return format;
    }

    avance_por_color = (avance) => {
        if (avance <= 0) return '#F02C00';
        if (avance < 30) return '#FC6903';
        if (avance < 50) return '#FC6903';
        if (avance < 70) return '#F3FF00';
        if (avance < 90) return '#AEFF00';
        if (avance > 100) return '#00BDFF';
        return '#02D61C';
    }
}